export interface IReward {
  referredUserId: string;
  referredName: string;
  percentage: number;
  amount: number;
  date: string;
  claimed: boolean;
  claimDate: string;
  rewardId: string;
  rewardAmount: number;
}

export interface IRewardFilters {
  claimed: boolean;
}

export interface ReferralEvent {
  referredByUserId: string;
  trackingType: TrackingType;
}

export interface ReferralStats {
  numClicks: number;
  numDayPass: number;
  numPremium: number;
  numSignups: number;
}

export enum TrackingType {
  Click,
  FreeAccount,
  DayPass,
  Premium,
}
